
export default (urlParameters) => {
  return {
    ads_allowed: true,
    nc_wind_toggle_allowed: true,
    proforecast_allowed: true,
    promo_modal_allowed: true
  }
}